import PigeonBadge from './pigeon';
import EggBadge from './egg';
import KumamonBadge from './kumamon';
import CocktailBadge from './cocktail';
import BombBadge from './bomb';
import BookBadge from './book';
import CoffeeBadge from './coffee';
import CupcakeBadge from './cupcake';
import DonutBadge from './donut';
import GameboyBadge from './gameboy';
import MonsterBadge from './monster';
import SneakerBadge from './sneaker';
import SubmarineBadge from './submarine';
import TVBadge from './tv';
import DogeBadge from './doge';
import WingsBadge from './wings';
import DoveBadge from './dove';
import YodaBadge from './yoda';
import IcebergBadge from './iceberg';
import IcecreamBadge from './icecream';
import RocketBadge from './rocket';
import PaperPlaneBadge from './paperPlane';
import LeafBadge from './leaf';
import MaskBadge from './mask';
import RainbowBadge from './rainbow';
import NewYearBadge from './bauble';

export const allBadges = [
  new EggBadge(),
  new SneakerBadge(),
  new CupcakeBadge(),
  new YodaBadge(),
  new WingsBadge(),
  new IcecreamBadge(),

  new KumamonBadge(),
  new CoffeeBadge(),
  new MonsterBadge(),
  new GameboyBadge(),
  new MaskBadge(),
  new IcebergBadge(),

  new PigeonBadge(),
  new DonutBadge(),
  new BookBadge(),
  new PaperPlaneBadge(),
  new RocketBadge(),
  new LeafBadge(),

  new DoveBadge(),
  new TVBadge(),
  new RainbowBadge(),
  new SubmarineBadge(),
  new CocktailBadge(),
  new NewYearBadge(),

  new BombBadge(),
  new DogeBadge(),
];



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/allBadges.ts